module.exports = __webpack_public_path__ + "static/media/viber.99384e58.svg";